// extracted by mini-css-extract-plugin
export default {"workorder_page":"area_workorder_page__apRnL","workorder_page_content":"area_workorder_page_content__ovJtv","left_center_right":"area_left_center_right__Haxh-"};